import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog, DialogActions, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface IdpDialogProps {
    open: boolean;
    onClose: () => void;
}

export const IdpDialog = ({ open, onClose }: IdpDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            sx={{
                zIndex: 1600,
            }}
            PaperProps={{
                sx: {
                    bgcolor: "#EDEDED",
                    borderRadius: 1,
                    border: "0.5px solid #000000",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.25)",
                    p: 0.5,
                },
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        position: "fixed",
                        backdropFilter: "blur(1px) !important",
                        WebkitBackdropFilter: "blur(1px) !important",
                        backgroundColor: "rgba(0, 0, 0, 0.35)",
                    },
                },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: "center",
                    color: PureLightThemeCaaS.colors.alpha.black[100],
                    fontWeight: 700,
                    p: 1,
                    pb: 0,
                    //   position: "relative",
                }}
            >
                Unfortunately, we do not support IDP leagues at this time.

            </DialogTitle>
            <DialogActions sx={{ justifyContent: "center", gap: 1 }}>
                <Button
                    variant="contained"
                    onClick={onClose}
                    autoFocus
                    sx={{
                        flex: 1,
                        whiteSpace: "nowrap",
                        p: 0.5,
                        bgcolor: PureLightThemeCaaS.colors.alpha.orange[100],
                        "&:hover": { bgcolor: PureLightThemeCaaS.colors.alpha.orange[90] },
                        width: "40%",
                    }}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};
